<script>
import {
  ref,
  nextTick,
  computed,
  watch,
  provide,
  onMounted,
} from "vue";
import BaseHeader from "./base-header.vue";
import BaseLeft from "./base-left.vue";
import PageContent from "./content.vue";
import { useQuasar } from "quasar";
import { useStore} from "vuex";
import {useRouter} from "vue-router";
export default {
  name: "layout-base",
  components: { BaseHeader, BaseLeft, PageContent },
  setup() {
    const store = useStore();
    let $q = useQuasar();
    const router = useRouter();
    let isRouterAlive = ref(true);
    const myRef = ref(null);
    provide("setPageReload", pageReload);
    function pageReload() {
      isRouterAlive.value = false;
      nextTick(() => {
        isRouterAlive.value = true;
      });
    }
    let isLogin = computed(() => store.getters["user/isLogin"]);
    let ApiResponse = computed(() => store.getters["response/ApiResponse"]);
    function check_session_user() {
      let userBase = localStorage.getItem('userBase');
      if (userBase == null) {
        store.commit('user/logout');
        router.push({name: 'login'});
      }
    }
    watch(isLogin, (v) => {
      if (!v) {
        gotoLogin();
      }
    });
    function gotoLogin() {
      store.commit('user/logout');
    }
    watch(
        ApiResponse,
        (v) => {
          $q.notify({
            progress: true,
            timeout: 3000,
            type: v.type,
            multiLine: true,
            position: "top-right",
            message: v.message,
            caption: v.caption ? v.caption : "",
          });
        },
        { deep: true }
    );
    onMounted(() => {
      store.dispatch('channel/socket_init', null, {root: true});
      check_session_user();
    });
    return { isRouterAlive, pageReload };
  },
};
// hHh lpR fFf
</script>
<template>
  <q-layout view="hhh lpr fFf" class="bg-grey-1">
    <base-header />
    <base-left />
    <page-content v-if="isRouterAlive" />
  </q-layout>
</template>
